// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sApRY","importantInfo":"styles_importantInfo__SE830"};